import React from 'react';
import { getEnvironment, setEnvironment, canChooseEnvironment } from '../utils/environment.mjs';

/**
 * Production/Test selector.
 *
 * Shown on the home page to admins and above, and on every page that renders it
 * while in Test (see canChooseEnvironment in ../utils/environment.mjs). Plain
 * users never see it. Switching persists the choice and reloads so every service
 * re-reads the API base and the sign-in flow targets the chosen backend.
 */
export default function EnvironmentCard({ user = null, className = 'mb-6' }) {
  if (!canChooseEnvironment(user)) {
    return null;
  }

  const current = getEnvironment();

  const choose = (env) => {
    if (env === current) return;
    setEnvironment(env);
    // Reload so module-level API bases and the sign-in target re-resolve.
    window.location.reload();
  };

  const optionClass = (active) =>
    `flex-1 min-h-[44px] sm:min-h-0 px-4 py-2 rounded-lg text-sm font-semibold border transition-colors ${
      active
        ? 'bg-stanford-red text-white border-stanford-red'
        : 'bg-white text-gray-700 border-gray-300 hover:border-stanford-red'
    }`;

  return (
    <div className={`${className} rounded-xl border border-gray-200 bg-gray-50 p-4`}>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
        Environment
      </p>
      <div className="flex gap-2">
        <button type="button" onClick={() => choose('production')} className={optionClass(current === 'production')}>
          Production
        </button>
        <button type="button" onClick={() => choose('test')} className={optionClass(current === 'test')}>
          Test
        </button>
      </div>
    </div>
  );
}
